import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import oncRatings from "../../../../src/data/articles/cube-prospective-phyrexia-all-will-be-one-commander/onc-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  oncRatings,
  ProspectiveIntro,
  React
};